import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/app-setting/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { Localization } from './localization/Localization';
import { LOCALIZATION } from 'drapcode-constant';

export class LocalizationSection extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
    actions.loadLocalizationData({ projectId });
  }

  render() {
    const { appSetting, actions, match } = this.props;
    const { projectDetail, permissionFlags, localization = [] } = appSetting;
    if (!projectDetail) {
      return '';
    }
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { projectId } = match.params;
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'localization'} projectDetail={projectDetail} />
        <Localization
          projectId={projectId}
          actions={actions}
          localization={localization}
          saveLocalizationConfig={actions.saveLocalizationConfig}
          deleteLocalizationConfig={actions.deleteLocalizationConfig}
          changeDefaultLanguage={actions.changeDefaultLanguage}
          addLocalizationKeyValue={actions.addLocalizationKeyValue}
          deleteLocalizationKeyValue={actions.deleteLocalizationKeyValue}
          updateLocalizationKeyValue={actions.updateLocalizationKeyValue}
          deleteFlag={permissionsArray.includes(LOCALIZATION)}
        />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocalizationSection);
